if (!customElements.get('jhat-lineup')) {
  customElements.define('jhat-lineup', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.copy = JSON.parse(this.querySelector('[data-copy]').textContent);
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.cards = Array.from(this.querySelector('[data-pool]').content.querySelectorAll('[data-card]'));
      this.select = this.querySelector('select');
      const models = [...new Set(this.cards.filter(c => c.dataset.kind === 'plate').map(c => c.dataset.model))].sort();
      models.forEach(model => this.select.add(new Option(model, model)));
      this.querySelector('[data-scale]').hidden = !models.length;
      this.select.addEventListener('change', () => this.renderPlates());
      this.onVariant = event => {
        if (!event.target.matches('input[name="id"]') || !event.target.closest('product-form')) return;
        const value = this.variants[event.target.value];
        if (!value) return;
        this.dataset.wood = value.wood;
        this.dataset.finish = value.finish;
        this.render();
      };
      document.addEventListener('change', this.onVariant);
      this.querySelector('details').addEventListener('toggle', event => {
        event.target.querySelector('summary span').textContent = event.target.open ? '−' : '＋';
      });
      this.render();
    }
    disconnectedCallback() {
      document.removeEventListener('change', this.onVariant);
      this.ready = false;
    }
    label(key) {
      return key.split(' ').map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(' ');
    }
    text(key) {
      const wood = this.label(this.dataset.wood);
      const material = this.dataset.finish === 'natural' ? wood : this.dataset.finish.toUpperCase();
      return this.copy[key].replaceAll('__MATERIAL__', material).replaceAll('__WOOD__', wood).replaceAll('__MODEL__', this.select.value);
    }
    matches(card) {
      return !!this.dataset.wood && card.dataset.wood === this.dataset.wood && card.dataset.finish === this.dataset.finish;
    }
    availableFirst(a, b) {
      return Number(b.dataset.available === 'true') - Number(a.dataset.available === 'true');
    }
    diverse(cards, limit) {
      const groups = new Map();
      cards.sort(this.availableFirst).forEach(card => {
        const key = card.dataset.kind;
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(card);
      });
      const result = [];
      while (result.length < limit && [...groups.values()].some(g => g.length)) {
        for (const group of groups.values()) {
          if (group.length && result.length < limit) result.push(group.shift());
        }
      }
      return result;
    }
    fill(selector, cards) {
      this.querySelector(selector).replaceChildren(...cards.map(card => card.cloneNode(true)));
    }
    render() {
      this.querySelector('[data-heading]').textContent = this.text(this.dataset.wood ? 'heading' : 'generic_heading');
      this.querySelector('[data-intro]').textContent = this.text(!this.dataset.wood ? 'generic_intro' : this.dataset.finish === 'natural' ? 'intro' : 'finish_intro');
      const items = this.cards.filter(c => c.dataset.kind !== 'plate');
      const matching = this.cards.filter(c => this.matches(c) && c.dataset.id !== this.dataset.productId);
      const unique = [...new Map(matching.map(c => [c.dataset.id, c])).values()];
      const plates = unique.filter(c => c.dataset.kind === 'plate' && c.dataset.model).sort(this.availableFirst);
      const models = new Set();
      const featuredPlates = plates.filter(c => {
        if (models.has(c.dataset.model)) return false;
        models.add(c.dataset.model);
        return true;
      }).slice(0, 2);
      const otherItems = this.diverse(unique.filter(c => c.dataset.kind !== 'plate'), 4);
      const same = otherItems.slice(0, featuredPlates.length ? 3 : 4);
      same.push(...featuredPlates.slice(0, 4 - same.length));
      this.fill('[data-same]', same);
      this.querySelector('[data-same]').hidden = !same.length;
      this.querySelector('[data-empty]').hidden = !!same.length || !this.dataset.wood;
      const other = this.diverse(items.filter(c => !this.matches(c)), 4);
      this.fill('[data-other-grid]', other);
      this.querySelector('[data-other]').hidden = !other.length;
      this.renderPlates();
    }
    renderPlates() {
      const result = this.querySelector('.jhat-lineup__results');
      result.hidden = !this.select.value;
      if (!this.select.value) { this.fill('[data-plates]', []); return; }
      const candidates = this.cards.filter(c => c.dataset.kind === 'plate' && c.dataset.model === this.select.value).sort(this.availableFirst);
      const exact = candidates.filter(c => this.matches(c));
      const chosen = exact.length ? exact.slice(0, 1) : candidates.slice(0, 2);
      const key = exact.length ? (exact[0].dataset.available === 'true' ? 'matched' : 'matched_sold') : (this.dataset.wood ? 'missing' : 'unknown');
      this.querySelector('[data-status]').textContent = this.text(key);
      this.fill('[data-plates]', chosen);
      const link = this.querySelector('[data-model-link]');
      const url = candidates.find(c => c.dataset.modelUrl)?.dataset.modelUrl;
      link.hidden = !url;
      if (url) { link.href = url; link.textContent = this.text('model_link'); }
      else link.removeAttribute('href');
    }
  });
}

